const GREEN_TINT = "#eaf1e6";
const BORDER = "#e9e4d2";
const TEXT = "#0e1a14";
const TEXT_2 = "#475148";
const TEXT_3 = "#7d847b";

const styles = {
  card: {
    background: "#ffffff",
    border: `1px solid ${BORDER}`,
    borderRadius: "16px",
    p: "22px 22px 14px",
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    gap: 1.5,
    mb: 0.5,
  },
  headerIconCircle: {
    width: 36,
    height: 36,
    borderRadius: "999px",
    background: GREEN_TINT,
    color: "primary.main",
    display: "grid",
    placeItems: "center",
    flexShrink: 0,
    fontSize: 16,
  },
  headerTitle: {
    fontSize: 16,
    fontWeight: 800,
    color: TEXT,
    lineHeight: 1.2,
  },
  headerSub: {
    fontSize: 13,
    color: TEXT_2,
    mt: "2px",
  },
  suggestionsCount: {
    fontSize: 12,
    color: TEXT_3,
    fontWeight: 600,
    flexShrink: 0,
  },
  divider: {
    borderColor: BORDER,
    my: "8px",
  },
  row: {
    display: "flex",
    alignItems: "flex-start",
    gap: 1.75,
    py: "10px",
    px: "4px",
  },
  rowIconCircle: {
    width: 36,
    height: 36,
    borderRadius: "999px",
    background: GREEN_TINT,
    color: "primary.main",
    display: "grid",
    placeItems: "center",
    flexShrink: 0,
    mt: "2px",
    fontSize: 14,
  },
  rowTitle: {
    fontSize: 15,
    fontWeight: 700,
    color: TEXT,
    lineHeight: 1.3,
  },
  rowDesc: {
    fontSize: 13,
    color: TEXT_2,
    mt: "2px",
    lineHeight: 1.45,
  },
  rowCta: {
    flexShrink: 0,
    px: 2,
    py: "8px",
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    color: "primary.main",
    borderColor: "#d6d0b9",
    "&:hover": {
      background: "#ffffff",
      borderColor: "primary.main",
    },
  },
  footer: {
    mt: 1,
  },
  dontShowAgain: {
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    color: TEXT_3,
    px: 1.5,
    py: 1,
    "&:hover": {
      background: GREEN_TINT,
      color: "primary.main",
    },
  },
};

export default styles;
